var $542f020fc9285606$exports = {};
$542f020fc9285606$exports = {
    "Empty": `Bo\u{15F}`
};


export {$542f020fc9285606$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
